import * as React from 'react';

import {Button} from 'shells/button/button';
import {NothingFoundEmptyState} from 'shells/empty-states/nothing-found-empty-state';

type Props = {
    onRemoveAllFilters: () => void;
};

export function NoResultsEmptyState(props: Props) {
    return (
        <div className='mt-16'>
            <NothingFoundEmptyState
                title=' '
                subtitle={
                    <>
                        Your search returned no results. Please update your filter criteria and try
                        again, or{' '}
                        <Button
                            variant='text-primary'
                            onClick={props.onRemoveAllFilters}
                            noPadding={true}
                            size='big'
                        >
                            clear your filters
                        </Button>{' '}
                        to start fresh.
                    </>
                }
            />
        </div>
    );
}
